@if (breadcrumb) {
    <div class="mijn-overzicht-template-breadcrumb ap-flex ap-flex-row ap-align-items-center">
        <ap-action-icon
            class="mijn-overzicht-template-breadcrumb__button"
            (onClick)="navigateBack()"
            [attr.aria-label]="'Terug naar ' + breadcrumb.label"
        >
            <ap-icon name="arrow-left" size="medium"></ap-icon>
            <span class="mijn-overzicht-template-breadcrumb__label">{{ breadcrumb.label }}</span>
        </ap-action-icon>
    </div>
}
